import React from "react";
import { Link } from "react-router-dom";
import { useGetTournaments } from "../apiCalls/tournamentApiCalls";
import { Container, Card } from "./ui";
import { ArrowRightIcon } from "./ui/icons";
import TournamentCard from "./TournamentCard";
import Loader from "./Loader";
import ErrorState from "./ErrorState";
import EmptyState from "./EmptyState";

export default function Tournaments() {
  const { data, isLoading, isError } = useGetTournaments();

  const tournaments = data?.data ?? [];
  // Upcoming first; fall back to whatever exists so the section is never blank
  // just because the calendar has rolled over.
  const upcoming = tournaments.filter((t) => t.status === "upcoming");
  const featured = (upcoming.length ? upcoming : tournaments).slice(0, 3);

  return (
    <section className="bg-surface py-16 md:py-20">
      <Container>
        <div className="mb-6 flex items-end justify-between gap-4">
          <h2 className="text-2xl font-bold tracking-tight text-navy md:text-3xl">
            Upcoming Tournaments
          </h2>
          <Link
            to="/searchTournaments"
            className="inline-flex shrink-0 items-center gap-1.5 text-sm font-semibold text-primary hover:text-primary-hover"
          >
            View all tournaments
            <ArrowRightIcon className="h-4 w-4" />
          </Link>
        </div>

        {isLoading && (
          <Card>
            <Loader label="Loading tournaments…" />
          </Card>
        )}
        {isError && (
          <Card>
            <ErrorState message="Could not load tournaments. Please try again." />
          </Card>
        )}
        {!isLoading && !isError && featured.length === 0 && (
          <Card>
            <EmptyState
              message="No tournaments have been announced yet."
              icon="🏆"
            />
          </Card>
        )}

        {featured.length > 0 && (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {featured.map((tournament) => (
              <TournamentCard key={tournament._id} tournament={tournament} />
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}
